import { createContext } from 'react'

const PuzzleContext = createContext()
export default PuzzleContext